import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-inlineblock hstack bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1" }, null, -1)
const _hoisted_2 = {
  tabindex: "-1",
  class: "tagwidth-150 text-truncate"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'hstack':_ctx.isHorizontal}, "gap-2"])
  }, [
    _renderSlot(_ctx.$slots, "label"),
    _createVNode(_component_Multiselect, {
      "model-value": _ctx.selectValue,
      class: _normalizeClass({'is-valid':_ctx.isComponentValid===true,'is-invalid':_ctx.isComponentValid===false}),
      options: _ctx.selectItems,
      mode: _ctx.mode,
      "close-on-select": true,
      label: 'label',
      rules: _ctx.getRules,
      searchable: true,
      "filter-results": true,
      strict: false,
      submit: false,
      disabled: _ctx.isDisabled,
      "disabled-prop": 'isDisabled',
      "native-support": true,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChange($event))),
      onClear: _withModifiers(_ctx.handleClear, ["prevent"]),
      classes: {
                            tag: 'bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1'
                        }
    }, {
      tag: _withCtx(({ option, handleTagRemove, disabled }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["multiselect-tag", {
            'is-disabled': disabled
          }])
        }, [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(option.label), 1),
          (!disabled)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "multiselect-tag-remove",
                onClick: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent"])
              }, _hoisted_5, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["model-value", "class", "options", "mode", "rules", "disabled", "onClear"])
  ], 2))
}